export default __webpack_public_path__ + "static/media/location_preview_s3_dazzling_dunes.f93309d8.svg";